import React from "react";
import "./style.scss";

type Props = {
  email: string | undefined;
};

const RegisterSuccess = ({ email }: Props) => {
  return (
    <section className="register-success-modal" data-testid="register-success">
      <h1 className="welcome-header">Welcome to Nasdaq Data Link!</h1>
      <h3
        className="small-header u-align-center f-kicker api-header"
        data-testid="email-message"
      >
        We have sent a verification email to {email ?? "your email address"}.
        Please follow the instructions in that email to activate your account.
      </h3>
      <p className="u-margin-bottom-40 api-description">
        Any help you need to get started using our data can be found in the{" "}
        <a
          href="https://help.data.nasdaq.com"
          data-testid="helpdoc-link"
          target="_blank"
          rel="noreferrer"
        >
          help
        </a>{" "}
        section.
      </p>
    </section>
  );
};

export default RegisterSuccess;
